import React from "react"
import moment from "moment"
import {createUseStyles, useTheme} from "react-jss"
import {GlobalToken} from "antd/es/theme/interface"

const useStyles = createUseStyles<string, {flexDirection: "row" | "column"}, GlobalToken>(() => ({
    dataTime: ({flexDirection}) => ({
        display: "flex",
        flexDirection: flexDirection,
        lineHeight: 1.2
    }),
    time: ({flexDirection}) => ({
        marginLeft: flexDirection === "row" ? "10px" : 0
    })
}))

interface DateTimeProps {
    dateTime?: string;
    direction?: "row" | "column";
    date?: string;
    time?: string;
}

const DateTime: React.FC<DateTimeProps> = ({dateTime, direction = "column", date, time}) => {
    const theme = useTheme<GlobalToken>()
    const classes = useStyles({theme, flexDirection: direction})

    return (
        <>
            <div className={classes.dataTime}>
                {dateTime && <div>{moment(dateTime).format("DD.MM.YYYY")}</div>}
                {dateTime && <div className={classes.time}>{moment(dateTime).format("HH:mm")}</div>}
                {date && <div>{moment(date).format("DD.MM.YYYY")}</div>}
                {time && <div className={classes.time}>{moment(time).format("HH:mm")}</div>}
            </div>
        </>
    )
}

export default DateTime
